<template>
  <section class="terms">
    <TermsAndConditions :isWebTarget="false"/>
    <FooterMobile />
  </section>
  
</template>

<script setup>
  import TermsAndConditions from "@/components/TermsAndConditions.vue";
  import FooterMobile from '../components/FooterAreaMobile.vue';
// import Header from "@/components/Header.vue";
// import mobFooter from "@/components/mobFooter.vue";
// export default {
//   name: "Terms_and_conditions",
//   components: {
//     // Header,
//     // mobFooter,
//   },
// };
</script>

<style scoped>
.terms {
  padding: 70px 0 0 0;
}
.textStyle {
  text-align: left;
}
.terms img {
  max-width: 100%;
}
.terms h2 {
  font-size: 55px;
  max-width: 100%;
  margin-bottom: 20px;
}
</style>
